import React, { useState, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import jsPDF from 'jspdf';

import { displayDate } from '../../Utils/dateFormatUtils';
import { searchObjInArray } from '../../Utils/arrayUtils';
import { displaySalesOrderNumber } from '../../Utils/displaySalesOrderNumber';
import apiCall from '../../Utils/apiCall';

import salesOrderTemplateJpg from '../../Utils/getSalesOrderTemplate';
import fontFile from '../../Utils/getIBMPlexFont';

import './SalesOrdersDataTable.css';

import {
	Button,
	Dropdown,
	Search,
	DataTableSkeleton,
	DataTable,
	Table,
	TableBatchAction,
	TableBatchActions,
	TableBody,
	TableCell,
	TableContainer,
	TableExpandHeader,
	TableExpandRow,
	TableExpandedRow,
	TableHead,
	TableHeader,
	TableRow,
	TableSelectAll,
	TableSelectRow,
	TableToolbar,
	TableToolbarAction,
	TableToolbarContent,
	TableToolbarSearch,
	TableToolbarMenu,
	OverflowMenu,
	OverflowMenuItem,
	ToastNotification,
} from 'carbon-components-react';

import { Upload20, Download20 } from '@carbon/icons-react';

function SalesOrdersDataTable(props) {
	//set history
	const history = useHistory();
	//get props
	const { token, salesOrdersData, loading, refreshData } = props;
	//define state
	const [dataDisplay, setDataDisplay] = useState(null);
	const [notification, setNotification] = useState(false);
	const [notificationContent, setNotificationContent] = useState({
		title: '',
		caption: '',
		type: 'info',
	});

	// console.log("PROPPI", props); //DEBUG

	//when component mounts, tidy up the data and set state to the props value
	useEffect(() => {
		if (salesOrdersData) {
			const formattedSalesOrdersData = salesOrdersData.map((salesOrder) => {
				let salesOrderFlat = {};
				salesOrderFlat.id = salesOrder._id;
				salesOrderFlat.salesOrderNumber = salesOrder.salesOrderNumber;
				salesOrderFlat.toName = salesOrder.to.name;
				// as per latest requirement, @tanishqsh
				salesOrderFlat.salesPerson = salesOrder.from.name;
				salesOrderFlat.firstShipDate = salesOrder.firstShipDate;
				salesOrderFlat.createdAt = salesOrder.created_at;
				salesOrderFlat.actions = true;
				return salesOrderFlat;
			});
			console.log('>>>>>', formattedSalesOrdersData);
			setDataDisplay(formattedSalesOrdersData);
		}
	}, []);

	//define headers for the datatable
	let headers = [
		{
			key: 'salesOrderNumber',
			header: 'Sales Order Number',
		},
		{
			key: 'toName',
			header: 'Customer',
		},
		{
			key: 'salesPerson',
			header: 'Sales Person',
		},
		{
			key: 'firstShipDate',
			header: 'First Ship Date',
		},
		{
			key: 'createdAt',
			header: 'Date Created',
		},
		{
			key: 'actions',
			header: 'Actions',
		},
	];

	// // handler functions
	// const _handleEditItem = (quoteId) => {
	//   console.log("EDITING QUOTE ID:", quoteId);
	//
	// }

	const _handleSalesOrderPDFGeneration = (salesOrderIndex) => {
		console.log('THEDATA>>>', salesOrdersData[salesOrderIndex]);
		const theData = salesOrdersData[salesOrderIndex];
		const fileName = `cwc_salesorder_${displaySalesOrderNumber(theData.salesOrderNumber)}`;

		let doc = new jsPDF();
		let quoteTotal = 0;

		doc.addImage(salesOrderTemplateJpg, 'JPEG', 0, 0, 210, 297);
		doc.setFont('IBMPlexSans-Regular', 'normal');

		doc.setFontSize(9);

		//data on the top right section
		let topRightX = 187.5;
		doc.text(`${displaySalesOrderNumber(theData.salesOrderNumber)}`, topRightX, 8.7);
		doc.text(`${displayDate(theData.created_at)}`, topRightX, 15);
		doc.text(`1 of 1`, topRightX, 21); //page 1
		doc.text(`${theData.customerPO}`, topRightX, 27.3);
		doc.text(`${!theData.firstShipDate ? '' : displayDate(theData.firstShipDate)}`, topRightX, 33.7);
		doc.text(`${!theData.firstShipDate ? '' : displayDate(theData.cancelDate)}`, topRightX, 39.7);
		doc.text(`${theData.shipVia}`, topRightX, 45.9);
		doc.text(`${theData.terms}`, topRightX, 52);
		doc.text(`${theData.from.salespersonNumber}`, topRightX, 58);

		//data on the SOLD TO section
		doc.text(`${theData.to.name}`, 10.5, 64.7);
		doc.text(`${theData.to.address1}`, 10.5, 71);
		doc.text(`${theData.to.address2}`, 10.5, 77.3);
		doc.text(`${theData.to.phone}`, 10.5, 83.6);

		//data on the DELIVERY ADDRESS section
		doc.text(`${!theData.to.nameDelivery ? '' : theData.to.nameDelivery}`, 84.5, 64.7);
		doc.text(`${theData.to.address1delivery}`, 84.5, 71);
		doc.text(`${theData.to.address2delivery}`, 84.5, 77.3);

		//data on NOTES and TOTAL sections
		doc.text(`${theData.notes}`, 11, 260, { maxWidth: 95 });

		let yCoord = 105.7;
		theData.items.map((item, i) => {
			doc.text(`${item.quantity}`, 11, yCoord);
			if (!item.sellUOM) {
				doc.text(`#`, 27, yCoord);
			} else {
				doc.text(`${item.sellUOM}`, 27, yCoord);
			}
			doc.text(`${item.description}`, 41, yCoord);
			doc.text(`${item.itemNumber}`, 111, yCoord);
			doc.text(`${item.listPrice}`, 151.4, yCoord);

			let listPriceNumber = item.listPrice.replace('$', '');

			let itemTotal = parseFloat(listPriceNumber) * parseInt(item.quantity);
			doc.text(`$${isNaN(itemTotal.toFixed(2)) ? '' : itemTotal.toFixed(2)}`, 181.4, yCoord);

			yCoord += 9.25;
			quoteTotal += itemTotal;
		});

		console.log(quoteTotal, 'ASDASD');
		// put the TOTAL
		doc.setFontSize(19);
		doc.text(`$ ${isNaN(quoteTotal.toFixed(2)) ? '' : quoteTotal.toFixed(2)}`, 151, 252);

		doc.save(fileName);

		return;
	};

	const _handleSalesOrderDelete = async (salesOrderIndex) => {
		console.log('THEDATA>>>', salesOrdersData[salesOrderIndex]);
		const salesOrderId = salesOrdersData[salesOrderIndex]._id;
		console.log('DELETING', salesOrderId);

		let confirmed = window.confirm(`Are you sure you want to delete this sales order?`);
		if (confirmed === false) return;

		//CALL API AND DELETE SALES ORDER

		const options = {
			method: 'DELETE',
		};
		const headers = {};
		const apiPath = `/sales-orders/${salesOrderId}`;

		const result = await apiCall(token, apiPath, options, headers);

		console.log('>>>>>>>', result);
		if (result.err || result.error) {
			setNotificationContent({
				title: 'Error',
				caption: result.err,
				type: 'error',
			});
			setNotification(true);
			return;
		}

		setNotificationContent({
			title: 'Success',
			caption: result.message,
			type: 'success',
		});
		setNotification(true);

		setTimeout(() => {
			setNotification(false);
			refreshData();
		}, 2500);
	};

	// if datadisp is empty, render the loading animation
	if (!dataDisplay) {
		return (
			<div id="skeletonDataTableCont">
				<DataTableSkeleton showToolbar={false} id="skeletonTable"></DataTableSkeleton>
			</div>
		);
	}

	// render the datatable in its full splendor
	return (
		<div id="quotesTableContainer">
			{notification ? (
				<ToastNotification
					lowContrast={false}
					className="appNotification slide-in-top"
					title={notificationContent.title}
					kind={notificationContent.type}
					caption={notificationContent.caption}
				/>
			) : null}
			<div id="dataTableContainer">
				<DataTable
					rows={dataDisplay}
					headers={headers}
					isSortable
					render={({
						rows,
						headers,
						getHeaderProps,
						getSelectionProps,
						getToolbarProps,
						getBatchActionProps,
						getRowProps,
						onInputChange,
						selectedRows,
						getTableProps,
						getTableContainerProps,
					}) => {
						return (
							<>
								{/*}
            <div id="dataActionsContainer">

            <Search labelText={"inventory search"} onChange={onInputChange} id="inventorySearchBar" placeHolderText={"Search Inventory"} />

            <Button id="refresh-data-button" onClick={() => handleRefreshData() }>
              Refresh
            </Button>

            </div>
            {*/}

								<TableContainer title="DataTable" description="Use the toolbar menu to interact with it" {...getTableContainerProps()}>
									<Table {...getTableProps()}>
										<TableHead>
											<TableRow>
												{headers.map((header, i) => {
													return (
														<TableHeader key={i} {...getHeaderProps({ header })}>
															{header.header}
														</TableHeader>
													);
												})}
											</TableRow>
										</TableHead>
										<TableBody>
											{rows.map((row, rowIndex) => (
												<React.Fragment key={row.id}>
													<TableRow {...getRowProps({ row })}>
														{row.cells.map((cell) => {
															if (cell.info.header === 'salesOrderNumber') {
																return <TableCell key={cell.id}>{displaySalesOrderNumber(cell.value)}</TableCell>;
															}

															if (cell.info.header === 'liveLink') {
																return (
																	<TableCell key={cell.id}>
																		<a href={cell.value}>http://portal.cwcdirect.com{cell.value}</a>
																	</TableCell>
																);
															}

															if (cell.info.header === 'firstShipDate' || cell.info.header === 'createdAt') {
																const formattedData = displayDate(cell.value);
																return <TableCell key={cell.id}>{formattedData}</TableCell>;
															}

															if (cell.info.header === 'actions') {
																return (
																	<TableCell key="actionsDropdown" className="bx--table-column-menu">
																		<OverflowMenu flipped>
																			<OverflowMenuItem
																				onClick={() => _handleSalesOrderPDFGeneration(rowIndex)}
																				itemText="Create Proforma Invoice"
																			></OverflowMenuItem>
																			<OverflowMenuItem
																				onClick={() => _handleSalesOrderPDFGeneration(rowIndex)}
																				itemText="Download"
																			></OverflowMenuItem>
																			<OverflowMenuItem
																				onClick={() => _handleSalesOrderDelete(rowIndex)}
																				isDelete
																				itemText="Delete"
																			></OverflowMenuItem>
																		</OverflowMenu>
																	</TableCell>
																);
															}

															// make the returned values uppercase
															return <TableCell key={cell.id}>{cell.value.toUpperCase()}</TableCell>;
														})}
													</TableRow>
												</React.Fragment>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</>
						);
					}}
				/>
			</div>
		</div>
	);
}

export default SalesOrdersDataTable;
